import { render, staticRenderFns } from "./AreaInfo.vue?vue&type=template&id=1ce45db9&scoped=true&"
import script from "./AreaInfo.vue?vue&type=script&lang=js&"
export * from "./AreaInfo.vue?vue&type=script&lang=js&"
import style0 from "./AreaInfo.vue?vue&type=style&index=0&id=1ce45db9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce45db9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ce45db9')) {
      api.createRecord('1ce45db9', component.options)
    } else {
      api.reload('1ce45db9', component.options)
    }
    module.hot.accept("./AreaInfo.vue?vue&type=template&id=1ce45db9&scoped=true&", function () {
      api.rerender('1ce45db9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/AreaInfo.vue"
export default component.exports